<form [formGroup]="companyForm" class="card">
  <div class="card-title text-center">
    <h3><strong>Re-connect to ShipStation</strong></h3>
    <h5>
      Your ShipStation <strong>API key</strong> has been <strong>removed</strong> or it <strong>no longer valid.</strong>
       Please <strong>re-connect</strong> with your <strong>API Key (V2)</strong> to continue syncing data.
    </h5>
  </div>
  <hr />

  <div class="form-group">
    <label><strong>Company Name*</strong></label>
    <input
      type="text"
      class="form-control"
      formControlName="companyName"
      placeholder="Company Name"
      [attr.disabled]="true"
    />
  </div>
  
  <div
    class="form-group"
  >
    <ng-template #tooltipContent>
      <span>Find your API Key in ShipStation:<br></span>
      <span>Account Settings ⟶ API Settings ⟶ Select API V2 ⟶ Generate API Keys.</span>
    </ng-template>
    <label class="form-label">
      <strong>API Key (V2)*</strong>
      <span 
        class="ml-2"
        [ngbTooltip]="tooltipContent" 
        tooltipClass="ship-station-tooltip">
        <i class="fas fa-info-circle cursor-pointer"></i>
      </span>
    </label>
    <div id="shipstation-input-container">
      <input
        class="form-control form-control-lg"
        type="text"
        formControlName="companyApiKey"
        [ngClass]="{
          'is-invalid':
            !companyApiKey.valid && (companyApiKey.dirty || companyApiKey.touched)
        }"
        [dataTestID]="'ship_station-api-input'"
      />
    </div>
    <div
      *ngIf="companyApiKey.errors && (companyApiKey.dirty || companyApiKey.touched)"
      class="text-danger small form-text"
    >
      <label *ngIf="companyApiKey.hasError('required')">
        <b>API key is required</b>
      </label>
      <label *ngIf="companyApiKey.hasError('apiKeyInvalid')">
        <b>API key is invalid, please try again</b>
      </label>
      <label *ngIf="companyApiKey.hasError('apiKeyTaken')">
        <b>API key is taken, please use another key</b>
      </label>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <button
      class="btn btn-secondary mx-1"
      (click)="activeModal.dismiss();"
    >
      Cancel
    </button>

    <button
      class="btn btn-success mx-1"
      [disabled]="!companyForm.valid"
      [ngStyle]="{
        cursor:
          companyForm.valid || !loading ? 'pointer' : 'not-allowed'
      }"
      (click)="updateCredentials()"
    >
      <ng-container *ngIf="loading">
        <span
        *ngIf="loading"
        class="spinner-border spinner-border-sm"
        ></span
        >&nbsp;
        <span  class="load-text">Connecting...</span>
      </ng-container>
      <span *ngIf="!loading">Connect</span>
    </button>
  </div>
</form>
